
import { STAFF_MEMBER_ADD, STAFF_MEMBER_CATEGORY_GET, STAFF_MEMBER_Delete, STAFF_MEMBER_Detail, STAFF_MEMBER_LIST, STAFF_MEMBER_LIST_SERVICE, STAFF_MEMBER_Status, STAFF_MEMBER_UPDATE, STAFF_MEMBER_VIEW_DEATILS } from "../Constants/StaffMemberConstants";
import { createGetDataReducer } from "./CommonReducer";

const StaffMemberListReducer = createGetDataReducer(STAFF_MEMBER_LIST);
const StaffMemberDetailReducer = createGetDataReducer(STAFF_MEMBER_Detail);
const StaffMemberUpdateReducer = createGetDataReducer(STAFF_MEMBER_UPDATE);
const StaffMemberAddReducer = createGetDataReducer(STAFF_MEMBER_ADD);
const StaffMemberDeleteReducer = createGetDataReducer(STAFF_MEMBER_Delete);
const StaffMemberStatusReducer = createGetDataReducer(STAFF_MEMBER_Status);
const StaffMemberCategoryServiceReducer = createGetDataReducer(STAFF_MEMBER_CATEGORY_GET);
const StaffMemberServiceListReducer = createGetDataReducer(STAFF_MEMBER_LIST_SERVICE);
const StaffMemberViewDetailReducer = createGetDataReducer(STAFF_MEMBER_VIEW_DEATILS);

export const StaffMemberReducers = {
    StaffMemberListState: StaffMemberListReducer,
    StaffMemberDetailState: StaffMemberDetailReducer,
    StaffMemberUpdateState: StaffMemberUpdateReducer,
    StaffMemberAddState: StaffMemberAddReducer,
    StaffMemberDeleteState: StaffMemberDeleteReducer,
    StaffMemberStatusState: StaffMemberStatusReducer,
    StaffMemberCategoryServiceState: StaffMemberCategoryServiceReducer,
    StaffMemberServiceListState: StaffMemberServiceListReducer,
    StaffMemberViewDetailState: StaffMemberViewDetailReducer
}